import React from "react";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../../../Authentication/LanguageContext";
import GrammarTranslations from "./GrammarTranslations";
import "./A1Grammar.css";

const grammarTopics = [
  { key: "Nouns", color: "#EF4444" },
  { key: "Articles", color: "#F59E0B" },
  { key: "Pronouns", color: "#10B981" },
  { key: "Adjectives", color: "#3B82F6" },
  { key: "Verbs", color: "#8B5CF6" },
  { key: "Tenses", color: "#F43F5E" },
  { key: "Cases", color: "#F97316" },
  { key: "Negation", color: "#22C55E" },
  { key: "Prepositions", color: "#0EA5E9" },
  { key: "Conjunctions", color: "#6366F1" },
  { key: "Imperatives", color: "#EC4899" },
  { key: "SentenceStructure", color: "#EAB308" },
];

const A1Grammar: React.FC = () => {
  const navigate = useNavigate();
  const { language } = useLanguage();

  const translations = {
    title: {
      en: "Grammatik",
      de: "Grammatik",
      ta: "இலக்கணம்",
      si: "ව්‍යාකරණය",
      hi: "व्याकरण",
      ar: "قواعد",
      tr: "Dilbilgisi",
      ru: "Грамматика",
      zh: "语法",
      fr: "Grammaire",
      es: "Gramática",
    },
    subtitle: {
      en: "Grammar",
      de: "Grammatik",
      ta: "இலக்கணம்",
      si: "ව්‍යාකරණය",
      hi: "व्याकरण",
      ar: "قواعد اللغة",
      tr: "Dilbilgisi",
      ru: "Грамматика",
      zh: "语法",
      fr: "Grammaire",
      es: "Gramática",
    },
  };

  const handleClick = (key: string) => {
    navigate(`/levels/a1/a1grammar/${key.toLowerCase()}`);
  };

  return (
    <div className="a1grammar-wrapper">
      <div className="a1grammar-header">
        <h1 className="a1grammar-title">{translations.title["de"]}</h1>
        <p className="a1grammar-subtitle">{translations.subtitle[language]}</p>
      </div>

      <div className="a1grammar-grid">
        {grammarTopics.map((topic) => {
          const germanText = GrammarTranslations["german"][topic.key];
          const translatedText =
            GrammarTranslations[language]?.[topic.key] ||
            GrammarTranslations["english"][topic.key];

          return (
            <div
              key={topic.key}
              className="a1grammar-card"
              onClick={() => handleClick(topic.key)}
              style={{ backgroundColor: topic.color }}
            >
              <div className="a1grammar-texts">
                <h3>{germanText}</h3>
                <p>{translatedText}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default A1Grammar;
